<template>
    <div>
        <xx-flow-graph
            v-if="data && data.length"
            ref="pipeline"
            :x="parseInt(config.x)"
            :y="parseInt(config.y)"
            :data="data"
            :ystep="parseInt(config.ystep)"
            :xstep="parseInt(config.xstep)"
            :tooltipClass="tooltipClass"
        />
    </div>
</template>

<script>
import { defaultFormat } from '../ApproveDetail/config';

export default {
    name: 'XxAuditFlow',
    props: {
        // 当前任务id
        taskId: {
            type: Number,
            default: 0,
        },
        // 场景值
        scene: {
            type: Number,
        },
        // 申请单id
        businessKey: {
            type: String,
            default: '',
        },
        // 自定义接口和参数，默认使用通用审批接口
        ajax: {
            type: Object,
            default: null,
        },
        formatFn: {
            type: Function,
            default: null,
        },
        tooltipClass: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            config: {
                x: 80,
                y: 25,
                xstep: 220,
                ystep: 80,
                data: 0,
                from: 0,
                to: 0,
            },
            originData: [], // 接口元数据
            data: [], // 渲染节点数据
        };
    },
    computed: {
        currentAudit() {
            let tempResult = this.originData.find(audit => audit.taskId === this.taskId);
            if (!tempResult) tempResult = this.originData[0] || null;
            return tempResult;
        },
    },
    methods: {
        async loadData() {
            const { businessKey, ajax, formatFn } = this;
            if (!businessKey) return;
            const url = (ajax && ajax.url) ? ajax.url : '/shepherd/product/approval/query-new-process-task-node-list';
            const params = (ajax && ajax.params) ? ajax.params : { scene: this.scene, businessKey: this.businessKey, };
            const response = await this.$hPost(url, params).catch(err => {
                this.$message.error(
                    err.message || err.msg || '获取审批信息失败',
                );
                return null;
            });

            if (!response) return;

            this.originData = response;

            this.data = formatFn ? formatFn(response, this) : defaultFormat(response, this);
        },
        $_reload() {
            this.loadData();
        }
    },
    watch: {
        businessKey: {
            handler() {
                this.loadData();
            },
            immediate: true,
        },
        // 向父级抛出 当前节点信息（用来操作 审批/驳回）
        currentAudit: {
            handler(val) {
                if (!val) return;
                this.$emit('syncAuditInfo', val);
            },
            immediate: true,
        }
    }
};
</script>
